<template>
  <v-app>
    <v-content class>
      <v-img
        :src="require('@/assets/bg_image.jpg')"
        :lazy-src="require('@/assets/bg_image_blur.jpg')"
        :height="this.$vuetify.breakpoint.height"
      >
        <LoginForm />
      </v-img>
    </v-content>
  </v-app>
</template>

<script>
// @ is an alias to /src
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "Home",
  components: {
    LoginForm
  }
};
</script>
